import { DRSSectionMaterial } from './material/Material'
import { DRSSectionRework } from './rework/Rework'
import { DRSSectionJob } from './job/Job'
import { DRSSectionTransport } from './transport/Transport'
import { DRSSectionMobileAssets } from './mobile-assets/MobileAsset'
import { DRSSectionSubcontractor } from './subcontractor/Subcontractor'
import { DRSSectionLabour } from './labour/Labour'
import { DRSSectionQa } from './qa/QA'
import { DRSSectionSummary } from './summary/Summary'

export enum DRSCostCategory {
  ShiftCost = 1,
  MobileAsset = 2,
  Subcontractor = 3,
  Material = 4,
  Cartage = 5,
  Labour = 6,
}

export interface DRSProjectCostItem {
  id: number,
  drsSummaryId: number,
  itemDescription: string,
  itemPrice: number,
  category: DRSCostCategory,
  isDeleted: boolean,
  dateCreated: string,
  dateModified: string,
}

export interface DRS {
  jobDetails: DRSSectionJob,
  rework: DRSSectionRework,
  material: DRSSectionMaterial,
  transport: DRSSectionTransport,
  mobileAssets: DRSSectionMobileAssets,
  subcontractor: DRSSectionSubcontractor,
  labour: DRSSectionLabour,
  qa: DRSSectionQa,
  summary: DRSSectionSummary,
  // Profitability fields
  projectRevenue?: number,
  planProjectRevenue?: number,
  comments?: string,
  projectCostItems?: DRSProjectCostItem[],
}

export type DRSSection = 
  DRSSectionJob | 
  DRSSectionRework | 
  DRSSectionMaterial | 
  DRSSectionTransport | 
  DRSSectionMobileAssets | 
  DRSSectionLabour | 
  DRSSectionQa | 
  DRSSectionSummary
